import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { generateDate, generateDateTerm } from 'libs/generateDate'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  startAt: string
  endAt: string
  announceAt: string
}

export const DateTermSectionForLottery: FC<Props> = ({
  startAt,
  endAt,
  announceAt,
}) => {
  const { xs } = useBreakpoint()
  const { t, i18n } = useTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: xs ? '16px' : '28px',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Typography.Text
          ellipsis
          style={{ fontSize: '12px', lineHeight: 1.5, color: colors.grey30 }}
        >
          {t('エントリー期間')}
        </Typography.Text>
        <Typography.Text
          style={{ fontSize: '14px', lineHeight: 1.5, color: colors.grey65 }}
        >
          {generateDateTerm({
            start: startAt,
            end: endAt,
            language: i18n.language,
          })}
        </Typography.Text>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Typography.Text
          ellipsis
          style={{ fontSize: '12px', lineHeight: 1.5, color: colors.grey30 }}
        >
          {t('当選発表日')}
        </Typography.Text>
        <Typography.Text
          style={{ fontSize: '14px', lineHeight: 1.5, color: colors.grey65 }}
        >
          {generateDate({
            dateTime: announceAt,
            language: i18n.language,
          })}
        </Typography.Text>
      </div>
    </div>
  )
}
